<template>
  <div class="w-full h-[1px] bg-grey-200" />
</template>
